<template>
  <Tabs value="name1" style="background-color:#fff; height:100%; margin:1px;">
        <TabPane label="Computer" icon="ios-laptop">
          <WebRTCVideo/>
        </TabPane>
        <TabPane label="Phone" icon="ios-call" style="padding:10px;">
          <p>London: </p>
          <p>Turkey: </p>
          <Divider />
          <p>Speaker PinCode: </p>
        </TabPane>
    </Tabs>
</template>
<script>
  import WebRTCVideo from './WebRTCVideo.vue'
  export default {
    data () {
      return {
        isReady: false,
        isOpen: true,
        resizable: true
      }
    },
    components: {
      WebRTCVideo
    }
  }
</script>
